import { Component } from '@angular/core';
import { ColmecTirePolicyService } from '../../../services/colmec-tire-policy.service';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { gungAddRemoveSpinner } from 'gung-standard';
import { first } from 'rxjs';

@Component({
    selector: 'colmec-tire-policy-import-modal',
    templateUrl: './colmec-tire-policy-import-modal.component.html',
    styleUrls: ['./colmec-tire-policy-import-modal.component.scss'],
    standalone: false
})
export class ColmecTirePolicyImportModalComponent {
  public isImporting: boolean = false;
  public selectedFile: File;

  constructor(
    protected colmecTirePolicyService: ColmecTirePolicyService,
    public activeModal: NgbActiveModal
  ) { }

  public onFileSelect(files: FileList): void {
    this.selectedFile = files?.[0];
  }

  public import({ target }): void {
    this.isImporting = true;
    gungAddRemoveSpinner(target);

    this.colmecTirePolicyService.importTirePolicy(this.selectedFile).pipe(first()).subscribe(_ => {
      this.isImporting = false;
      gungAddRemoveSpinner(target);
      this.activeModal.close();
    });
  }

  public crossClick(): void {
    this.activeModal.dismiss();
  }
}
